export default function PrivacyPolicy() {
  window.location.replace("/pdf/boreas_privacy_policy_7_2024.pdf");
}
